export { default } from "./Table.js";
